module.exports = __webpack_public_path__ + "img/desburocratizacao_ouro.958df4ff.png";